import { Navigate, useLocation } from "react-router-dom";
import { useAuthState } from "@/hooks/useAuthState";
import { useMonitorRedirect } from "@/hooks/useMonitorRedirect";
import {
  useRecepcionistaRedirect,
  isRecepcionistaAllowedPath,
} from "@/hooks/useRecepcionistaRedirect";
import { useProfileQuery } from "@/hooks/profile/useProfileQuery";
import { LoadingState } from "./LoadingState";

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, loading } = useAuthState();
  const { isMonitor, isCheckingRole } = useMonitorRedirect();
  const { isPureRecepcionista, isCheckingRole: isCheckingRecep } = useRecepcionistaRedirect();
  const { data: profile, isLoading: isLoadingProfile } = useProfileQuery();
  const location = useLocation();

  if (loading || isCheckingRole || isCheckingRecep) {
    return <LoadingState />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/intro" replace />;
  }

  // Force password change after admin/manager reset.
  // Wait for profile to load to avoid a flash; once loaded, if must_change_password
  // is true, redirect to the dedicated page.
  if (
    !isLoadingProfile &&
    profile?.must_change_password === true &&
    location.pathname !== "/forzar-cambio-password"
  ) {
    return <Navigate to="/forzar-cambio-password" replace />;
  }

  if (isMonitor && location.pathname !== "/monitor") {
    return <Navigate to="/monitor" replace />;
  }

  // Only PURE recepcionistas (whose primary profile role is recepcionista) get
  // auto-redirected to the panel. Users with a dual role (e.g. profesor that
  // also has recepcionista access) keep free navigation.
  if (isPureRecepcionista && !isRecepcionistaAllowedPath(location.pathname)) {
    return <Navigate to="/recepcionista" replace />;
  }

  return <>{children}</>;
};
